__turbopack_context__.v({
  "contact": "SttW4q_contact",
  "dates": "SttW4q_dates",
  "divider1": "SttW4q_divider1",
  "divider2": "SttW4q_divider2",
  "divider3": "SttW4q_divider3",
  "emailNotificationGroup": "SttW4q_emailNotificationGroup",
  "eventDate": "SttW4q_eventDate",
  "label1": "SttW4q_label1",
  "label2": "SttW4q_label2",
  "organizationAndSharableLink": "SttW4q_organizationAndSharableLink",
  "status": "SttW4q_status",
  "title": "SttW4q_title",
  "titleText": "SttW4q_titleText",
  "value1": "SttW4q_value1",
  "value2": "SttW4q_value2",
});
